// @ts-nocheck
import { AbstractTextMessage } from "./AbstractTextMessage";

export class TextMessage extends AbstractTextMessage {
  constructor() {
    super();
  }
}
